<div class="list-blocks__container" empathyInfiniteScroll (loadMore)="onLoadMore()">
  <div class="list-blocks__header">
    <div class="list-blocks__header-title">
      <span class="fs__lg fw__500">Blocks</span>
    </div>
  </div>

  <div class="list-blocks__list">
    <mat-action-list>
      @for (row of visibleRows$(); track row.id) {
        <div class="list-blocks__list-row">
          <empathy-list-block-item [active]="row.id === blocks.active$()?.value.id" [row]="row" (activate)="blocks.activeIndex$.set(row.blockIndex)" />
        </div>
      }
    </mat-action-list>
  </div>
</div>
